import { bus } from "../core/bus";

export class PhaseHud {
  private readonly el: HTMLElement;
  private currentIndex = 0;
  private pulse = 0;
  private lastHtml = "";

  constructor(
    private readonly enabled: boolean,
    private readonly labels: string[],
  ) {
    const el = document.querySelector("[data-slot='phase']") as HTMLElement | null;
    if (!el) throw new Error("Missing HUD phase slot");
    this.el = el;
    this.el.classList.toggle("is-visible", enabled);
    bus.on("squad:waypointReached", this.onWaypointReached);
    this.render();
  }

  update(dt: number): void {
    if (!this.enabled) return;
    this.pulse = Math.max(0, this.pulse - dt);
    this.render();
  }

  dispose(): void {
    bus.off("squad:waypointReached", this.onWaypointReached);
    this.el.classList.remove("is-visible");
    this.el.innerHTML = "";
  }

  private readonly onWaypointReached = ({ index }: { index: number }): void => {
    this.currentIndex = Math.min(index + 1, this.labels.length - 1);
    this.pulse = 1.35;
  };

  private render(): void {
    const label = this.labels[this.currentIndex] ?? "ROUTE";
    const progress = `${String(this.currentIndex + 1).padStart(2, "0")}/${String(this.labels.length).padStart(2, "0")}`;
    const pulse = this.pulse > 0 ? " is-pulsing" : "";
    const html = !this.enabled ? "" : `
      <div class="hud-phase__panel${pulse}">
        <div class="hud-phase__kicker">TACTICAL PHASE</div>
        <div class="hud-phase__label">${label}</div>
        <div class="hud-phase__meta"><span>ROUTE ${progress}</span><span>ANCHOR SCAN</span></div>
      </div>
    `;
    // Content only changes on waypoint events / pulse expiry — skip the
    // per-frame DOM write otherwise.
    if (html === this.lastHtml) return;
    this.lastHtml = html;
    this.el.innerHTML = html;
  }
}
